/**
 * Account API client — wraps POST /account/delete.
 *
 * Uses Amplify fetchAuthSession to attach the Cognito JWT Authorization header.
 * Sub is extracted server-side from JWT claims — never sent in the request body.
 */

import { fetchAuthSession } from 'aws-amplify/auth';

const REST_BASE = ((import.meta.env.VITE_REST_API_URL as string | undefined) ?? '').replace(/\/$/, '');

async function getAuthHeader(): Promise<string> {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  if (!token) throw new Error('Not authenticated');
  return `Bearer ${token}`;
}

/**
 * Permanently deletes the authenticated user's account and all associated data.
 * Throws on non-200 response. Returns void on success.
 */
export async function deleteAccount(): Promise<void> {
  const auth = await getAuthHeader();
  const res = await fetch(`${REST_BASE}/account/delete`, {
    method: 'POST',
    headers: { Authorization: auth },
  });
  if (!res.ok) throw new Error(`POST /account/delete failed: ${res.status}`);
}
